import React from 'react';
import LoadingThinkingIcon from '@/comp/common/icons/LoadingThinkingIcon';
import * as S from './LoadingThinkingIndicator.styles';

interface LoadingThinkingIndicatorProps {
  className?: string;
}

const LoadingThinkingIndicator: React.FC<LoadingThinkingIndicatorProps> = ({ className }) => {
  return (
    <S.LoadingIndicatorContainer className={className}>
      <LoadingThinkingIcon width={45} height={45} />
      <S.ThinkingText>Thinking</S.ThinkingText>
    </S.LoadingIndicatorContainer>
  );
};

export default LoadingThinkingIndicator;
